'use client';

import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import type { LinkProps as ReactAriaLinkProps } from 'react-aria-components';
import { Link as ReactAriaLink } from 'react-aria-components';

import { useFusionTheme } from '../hooks';

import styles from './Link.module.scss';

export type LinkProps = ReactAriaLinkProps &
  React.RefAttributes<HTMLAnchorElement> &
  VariantProps<typeof linkVariants>;

const linkVariants = cva(styles.link, {
  variants: {
    size: {
      extraSmall: styles.sizeExtraSmall,
      small: styles.sizeSmall,
      default: styles.sizeDefault,
      large: styles.sizeLarge
    }
  }
});

const Link = ({ size = 'default', className, children, ...linkProps }: LinkProps) => {
  const { addThemeClassName } = useFusionTheme();

  return (
    <ReactAriaLink {...linkProps} className={addThemeClassName(linkVariants({ size }), className)}>
      {children}
    </ReactAriaLink>
  );
};

export default Link;
